import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=304921b8&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=ts&"
export * from "./guide.vue?vue&type=script&lang=ts&"
import style0 from "./guide.vue?vue&type=style&index=0&id=304921b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304921b8",
  null
  
)

export default component.exports